import { sharedContactsReducer as contacts, SharedContactsState } from './contacts';
import { sharedGroupsReducer as groups, SharedGroupsState } from './groups';
import {
  sharedContactHighlightsReducer as highlights,
  SharedContactHighlightsState,
} from './highlights';
import { sharedContactMomentsReducer as moments, SharedContactMomentsState } from './moments';
import { sharedNotesReducer as notes, SharedNotesState } from './notes';
import { sharedContactSourcesReducer as sources, SharedContactSourcesState } from './sources';

export interface AppSharedData {
  contacts: SharedContactsState;
  groups: SharedGroupsState;
  highlights: SharedContactHighlightsState;
  moments: SharedContactMomentsState;
  notes: SharedNotesState;
  sources: SharedContactSourcesState;
}

export default {
  contacts,
  groups,
  highlights,
  moments,
  notes,
  sources,
};
